import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, ViewContainerRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';

import { DataSourceRequestState } from '@progress/kendo-data-query';

import { ExportService } from '@shared/services/export';
import { FSliteTradeService } from '@fs/services/trades';
import { TabOpenService } from '@services/tab-open.service';

import { ActionName } from '@shared/enums/action-name';
import { CommonMethods } from '@services/common.method';
import { Constants } from '@shared/models/constants';
import { ExportColumnHeaders } from '@shared/models/export-headers.model';
import { IExport } from '@shared/interfaces/IExcelExport';
import { MapExportData } from '@shared/data/MapExportData';
import { PermissionPipe } from '@shared/pipes/permission';
import { NotificationsService } from '@shared/services/notification';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { Grid } from '@fs/enums/grid.enum';
import { FsUtil } from '@fs/services/fs-utils';

@Component({
  selector: 'app-trade-list',
  templateUrl: './trade-list.component.html',
  styleUrls: ['./trade-list.component.scss'],
  providers: [FSliteTradeService]
})

export class TradeListComponent implements OnInit, AfterViewInit {

  //#region Input/Output
  @ViewChild("elAdvancedSearch") elAdvancedSearch: ElementRef;
  @ViewChild("elAdvancedSearchOption") elAdvancedSearchOption: any;
  @ViewChild("treeViewList") treeViewList: any;
  @ViewChild('catDeletePreview') catDeletePreview: ElementRef;
  @ViewChild('catDragAndDropImage') catDragAndDropImage: ElementRef;
  @ViewChild('catImagePreview') catImagePreview: ElementRef;
  @ViewChild('catUploadImageBtn') catUploadImageBtn: ElementRef;
  @ViewChild('subCatDeletePreview') subCatDeletePreview: ElementRef;
  @ViewChild('subCatDragAndDropImage') subCatDragAndDropImage: ElementRef;
  @ViewChild('subCatImagePreview') subCatImagePreview: ElementRef;
  @ViewChild('subCatUploadImageBtn') subCatUploadImageBtn: ElementRef;
  @ViewChild('tradeDeletePreview') tradeDeletePreview: ElementRef;
  @ViewChild('tradeDragAndDropImage') tradeDragAndDropImage: ElementRef;
  @ViewChild('tradeImagePreview') tradeImagePreview: ElementRef;
  @ViewChild('tradeUploadImageBtn') tradeUploadImageBtn: ElementRef;
  @ViewChild("viewChildTradeForm") viewChildTradeForm: ElementRef;
  @ViewChild("viewChildCategoryForm") viewChildCategoryForm: ElementRef;
  @ViewChild("viewChildSubCategoryForm") viewChildSubCategoryForm: ElementRef;
  
  //#endregion

  //#region Variables Declarations 

  private deleteDataItem: any;
  private destroyTab: boolean = false;
  private isUnsavedTriggered: boolean = false;
  private advanceFiltersValues: any = null;

  public deleteMessage: string = "";
  public showDeleteConfirmation: boolean = false;
  public actionName = ActionName;
  public trades: any[] = [];
  public advancedFilterFields = [];
  public expandedKeys = [];
  public allTrades = [];
  public categoryList = [];
  public childCount: number = 0;
  public defaultImage: string = Constants.DefaultImagePaths.Category;
  public itemCount: number = 0;
  public tabCounter: number;
  public tradeForm: FormGroup;
  public categoryForm: FormGroup;
  public subCategoryForm: FormGroup;
  public customFilterForm: FormGroup;
  public imageUploading: boolean = false;
  public emptyRecord: boolean = false;
  public state: DataSourceRequestState = {
    skip: 0,
    take: 50
  };
  public modalOptions: {
    showTrade: boolean,
    showCategory: boolean,
    showSubCategory: boolean,
    isEdit: boolean
  } = {
      showTrade: false,
      showCategory: false,
      showSubCategory: false,
      isEdit: false
    };
    public allowedextensionsforAttachment :string = '';
    public allowedsizeforAttachment :number = 0;
  //#endregion

  constructor(
    private exportService: ExportService,
    private permissionPipe: PermissionPipe,
    private toastr: NotificationsService,
    private frmbuilder: FormBuilder,
    private commonMethods: CommonMethods,
    private _elementRef: ElementRef,
    private dataService: FSliteTradeService,
    private tabopen: TabOpenService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef
  ) {
    FsUtil.configFilters(this.advancedFilterFields, Grid.Category);
    this.IntializeFilters();
    this.tabopen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.destroyTab = true;
        setTimeout(() => {
          $(this._elementRef.nativeElement).find(".modalSave").click();
        }, 100)
      }
    })
    this.tabopen.destroyModalEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter && response.event == "destroy") {
        this.modalOptions.showCategory = false;
        this.modalOptions.showSubCategory = false;
        this.modalOptions.showTrade = false;
        this.modalOptions.isEdit = false;
        this.TriggerUnsavedChagesDetected(false, false);
      }
      else if (response.tabCounter == this.tabCounter && response.event == "save") {
        setTimeout(() => {
          $(this._elementRef.nativeElement).find(".modalSave").click();
        }, 100)
      }
    })

    this.allowedextensionsforAttachment = this.commonMethods.FileExtensionArrayToCommaSeparatedString(Constants.DefaultImageExtension);
    this.allowedsizeforAttachment = Constants.DefaultFileSize.inMegabytes;
  }

  //#region Life-Cycle Events

  ngAfterViewInit(): void {

  }

  ngOnInit() {
    this.GetTrades();
  }

  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let isDirty = (this.subCategoryForm != undefined && this.subCategoryForm.dirty && this.modalOptions.showSubCategory) || (this.categoryForm != undefined && this.categoryForm.dirty && this.modalOptions.showCategory) || (this.tradeForm != undefined && this.tradeForm.dirty && this.modalOptions.showTrade)
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabopen.unsavedChangedDetected({ dirty: isDirty, Index: this.tabCounter });
      }
    }
  }

  //#endregion
  
  //#region Private methods
  private IntializeFilters() {
    this.customFilterForm = this.frmbuilder.group({
      "searchFilters": this.frmbuilder.array([]),
      "searchString": new FormControl(""),
    });
  }

  private FindTradeID(categoryID: string) {
    let tradeID = "";
    this.trades.forEach(x => {
      if (x.Children.length > 0) {
        x.Children.forEach(y => {
          if (y.ID == categoryID) {
            tradeID = x.ID;
          }
        })
      }

    })
    return tradeID;
  }

  private IntializeTradeForm(item = null) {
  
    if (item != null) {
      this.tradeForm = this.frmbuilder.group({
        ID: new FormControl(item.ID),
        Name: new FormControl(item.Name, [Validators.required, this.commonMethods.noWhitespaceValidator, Validators.maxLength(50)]),
        ImagePath: new FormControl(item.ImagePath == null ? "" : item.ImagePath),
        ModifyDate: new FormControl(item.ModifyDate)
      })
      if (item.ImagePath != "" && item.ImagePath != null) {
        setTimeout(() => {
          $(this.tradeImagePreview.nativeElement).show();
          $(this.tradeDragAndDropImage.nativeElement).hide();
          $(this.tradeUploadImageBtn.nativeElement).show();
          $(this.tradeDeletePreview.nativeElement).show()
        }, 100)
      }
      this.childCount = item.Children.length;
    }
    else {
      this.tradeForm = this.frmbuilder.group({
        ID: new FormControl(""),
        Name: new FormControl("", [Validators.required, this.commonMethods.noWhitespaceValidator, Validators.maxLength(50)]),
        ImagePath: new FormControl(""),
        ModifyDate: new FormControl("")
      })
    }
  }

  private IntializeCategoryForm(item = null) {
 
    if (item != null) {
      this.categoryForm = this.frmbuilder.group({
        ID: new FormControl(item.ID),
        OldParentId: new FormControl(item.ParentID),
        Name: new FormControl(item.Name, [Validators.required, this.commonMethods.noWhitespaceValidator, Validators.maxLength(50)]),
        ImagePath: new FormControl(item.ImagePath == null ? "" : item.ImagePath),
        ParentId: new FormControl(item.ParentID, Validators.required),
        ModifyDate: new FormControl(item.ModifyDate)
      })
      if (item.ImagePath != "" && item.ImagePath != null) {
        setTimeout(() => {
          $(this.catImagePreview.nativeElement).show();
          $(this.catDragAndDropImage.nativeElement).hide();
          $(this.catUploadImageBtn.nativeElement).show();
          $(this.catDeletePreview.nativeElement).show()
        }, 100)
      }
      this.childCount = item.Children.length;
      this.itemCount = item.ItemCount;
    }
    else {
      this.categoryForm = this.frmbuilder.group({
        ID: new FormControl(""),
        OldParentId: new FormControl(""),
        Name: new FormControl("", [Validators.required, this.commonMethods.noWhitespaceValidator, Validators.maxLength(50)]),
        ImagePath: new FormControl(""),
        ParentId: new FormControl("", Validators.required),
        ModifyDate: new FormControl("")
      })
    }
  }

  private IntializeSubCategoryForm(tradeID = null, dataItem = null) {

    if (tradeID == null) {
      this.subCategoryForm = this.frmbuilder.group({
        Name: new FormControl("", [Validators.required, this.commonMethods.noWhitespaceValidator, Validators.maxLength(50)]),
        ImagePath: new FormControl(""),
        ParentId: new FormControl("", Validators.required),
        OldParentId: new FormControl(""),
        ID: new FormControl(""),
        OldTradeId: new FormControl(""),
        TradeId: new FormControl("", Validators.required),
        ModifyDate: new FormControl("")
      })
    }
    else {
      this.subCategoryForm = this.frmbuilder.group({
        Name: new FormControl(dataItem.Name, [Validators.required, this.commonMethods.noWhitespaceValidator, Validators.maxLength(50)]),
        ImagePath: new FormControl(dataItem.ImagePath),
        ID: new FormControl(dataItem.ID),
        ParentId: new FormControl(dataItem.ParentID, Validators.required),
        OldParentId: new FormControl(dataItem.ParentID),
        TradeId: new FormControl(tradeID, Validators.required),
        OldTradeId: new FormControl(tradeID),
        ModifyDate: new FormControl(dataItem.ModifyDate)
      })
      if (dataItem.ImagePath != "" && dataItem.ImagePath != null) {
        setTimeout(() => {
          $(this.subCatImagePreview.nativeElement).show();
          $(this.subCatDragAndDropImage.nativeElement).hide();
          $(this.subCatUploadImageBtn.nativeElement).show();
          //$(ImagePreview).attr('src', e.target.result);
          $(this.subCatDeletePreview.nativeElement).show()
        }, 100)
      }
    }
    this.itemCount = dataItem != null ? dataItem.ItemCount : 0;
  }

  private SortList() {
    let key = "Name"
    this.trades = this.trades.sort(function (a, b) {
      var x = a[key].toUpperCase(); var y = b[key].toUpperCase();
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
    this.trades.forEach(element => {
      element.Children = element.Children.sort(function (a1, b1) {
        var x = a1[key].toUpperCase(); var y = b1[key].toUpperCase();
        return ((x < y) ? -1 : ((x > y) ? 1 : 0))
      });
      element.Children.forEach(element1 => {
        element1.Children = element1.Children.sort(function (a2, b2) {
          var x = a2[key].toUpperCase(); var y = b2[key].toUpperCase();
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        });
      });
    })    
  }

  private AdvanceSearch(filters: any) {
    let searchString = "";
    //this.expandedKeys = [];
    let trades = [];
    if (filters == null) {
      return;
    }
    if (filters.find(x => x.field == "AllNames") != undefined) {
      trades = [];
      searchString = filters.find(x => x.field == "AllNames").value.toUpperCase();
      this.trades.forEach(x => {
        if (this.AdvanceFilters(filters, "AllNames", x) == true) {
          trades.push(x);
          x.Children.forEach(y => {
            if (this.AdvanceFilters(filters, "AllNames", y) == true) {
              this.expandedKeys.indexOf(x.ID) > -1 ? "" : this.expandedKeys.push(x.ID);
              y.Children.forEach(z => {
                if (this.AdvanceFilters(filters, "AllNames", z) == true) {
                  if (this.expandedKeys.indexOf(y.ID) == -1) { this.expandedKeys.push(y.ID) }
                  if (this.expandedKeys.indexOf(x.ID) == -1) {
                    this.expandedKeys.push(x.ID)
                  }
                }
              })
            }
            else {
              y.Children.forEach(z => {
                if (this.AdvanceFilters(filters, "AllNames", z) == true) {
                  if (this.expandedKeys.indexOf(y.ID) == -1) { this.expandedKeys.push(y.ID) }
                  if (this.expandedKeys.indexOf(x.ID) == -1) {
                    this.expandedKeys.push(x.ID)
                  }
                }
              })
            }
          })
        }
        else {
          x.Children.forEach(y => {
            if (this.AdvanceFilters(filters, "AllNames", y) == true) {
              if (trades.indexOf(x) == -1) {
                trades.push(x)
                this.expandedKeys.push(x.ID)
              }
              y.Children.forEach(z => {
                if (this.AdvanceFilters(filters, "AllNames", z) == true) {
                  if (this.expandedKeys.indexOf(y.ID) == -1) {
                    this.expandedKeys.push(y.ID)
                  }
                }
              })
            }
            else {
              y.Children.forEach(z => {
                if (this.AdvanceFilters(filters, "AllNames", z) == true) {
                  if (trades.indexOf(x) == -1) {
                    trades.push(x)
                    this.expandedKeys.push(x.ID)
                    this.expandedKeys.push(y.ID)
                  }
                }
              })
            }
          })
        }
      })
      this.trades = trades;
    }

    if (filters.find(x => x.field == "CategoryName") != undefined) {
      trades = [];
      this.trades.forEach(x => {
        x.Children.forEach(y => {
          if (this.AdvanceFilters(filters, "CategoryName", y) == true) {
            if (trades.indexOf(x) == -1)
              trades.push(x);
            this.expandedKeys.indexOf(x.ID) > -1 ? "" : this.expandedKeys.push(x.ID);
          }
        });
      });
      this.trades = trades;
    }

    if (filters.find(x => x.field == "SubCategoryName") != undefined) {
      trades = [];
      this.trades.forEach(x => {
        x.Children.forEach(y => {
          y.Children.forEach(z => {

            if (this.AdvanceFilters(filters, "SubCategoryName", z) == true) {
              if (trades.indexOf(x) == -1)
                trades.push(x);
              this.expandedKeys.indexOf(x.ID) > -1 ? "" : this.expandedKeys.push(x.ID);
              this.expandedKeys.indexOf(y.ID) > -1 ? "" : this.expandedKeys.push(y.ID);
            }
          });
        });
      });
      this.trades = trades;
    }

    this.NoRecordFound(this.trades);
    this.SortList();
  }

  private AdvanceFilters(filters: any, type: any, field: any) {
    let returnVal = true;
    let fieldName = field.Name.toUpperCase();
    //var x = filters.find(x => x.field == type);
    let filterArray = filters.filter(x => x.field == type);
    for (let i = 0; i < filterArray.length; i++) {
      let x = filterArray[i];
      if (x.field == type || x.field == "AllNames") {
        var op = x.operator;
        let searchString = x.value.toUpperCase();
        if (searchString != "") {
          //Leave it as is even though not part of lite
          if (x.field == "HasImage") {
            var nodeHasImage = ((field.ImagePath != "") && (field.ImagePath != null)) ? "TRUE" : "FALSE";
            var op = x.operator;
            var searchValue = x.value.toUpperCase();
            switch (op) {
              case "eq":
                returnVal = (nodeHasImage == searchValue) ? true : false;
                break;
            }
          }
          else {
            switch (op) {
              case "c":
                returnVal = fieldName.indexOf(searchString) > -1 ? true : false;
                break;

              case "eq":
                returnVal = (fieldName == searchString) ? true : false;
                break;

              case "neq":
                returnVal = (fieldName != searchString) ? true : false;
                break;

              case "dnc":
                returnVal = fieldName.indexOf(searchString) <= -1 ? true : false;
                break;

              case "nb":
                returnVal = true;
                break;

              case "b":
                returnVal = false;
                break;

              default:
                returnVal = false;
            }
          }
        }
      }
      if (!returnVal)
        i = filterArray.length;
    }

    return returnVal;
  }

  private GetTrades() {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    this.dataService.fetch("", this.state, this.customFilterForm.controls['searchString'].value)
      .subscribe(r => {
        this.trades = r.Children;
        this.SortList();
        this.allTrades = r.Children;
        this.NoRecordFound(this.trades);
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      },(error:any)=>{this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);});
  }

  private NoRecordFound(value: any) {
    if (value == null || value == undefined || value.length == 0) {
      this.emptyRecord = true;
    }
    else {
      this.emptyRecord = false;
    }
  }

  private InitiateExportData(): IExport {
    return {
      exportData: this.CreateExportData(this.trades).map(x => MapExportData.mapProductCategory(x)),
      exportHeadersColumns: ExportColumnHeaders.ProductCategories,
      columnHeaderNotToBeIncluded: []
    }
  }

  private CreateExportData(arrayNode: any[]): any[] {
    var printarray = [];
    arrayNode.forEach(x => {
      var innerResult = {};
      if (x.Level == 2) {
        innerResult['Trade'] = x.Name;
        innerResult['Category'] = '';
        innerResult['SubCategory'] = '';
        printarray.push(innerResult); // first child pushed as Trade
        innerResult = {};
      }
      innerResult = {};
      if (x.Children.length > 0) {
        x.Children.forEach(y => {
          if (y.Level == 3) {
            innerResult['Trade'] = x.Name;
            innerResult['Category'] = y.Name;
            innerResult['SubCategory'] = '';
            printarray.push(innerResult); // Second child pushed as Category
            innerResult = {};
          }
          innerResult = {};
          if (y.Children.length > 0) {
            y.Children.forEach(z => {
              if (z.Level == 4) {
                innerResult['Trade'] = x.Name;
                innerResult['Category'] = y.Name;
                innerResult['SubCategory'] = z.Name;
                printarray.push(innerResult); // Third child pushed as Sub Category
                innerResult = {};
              }
            })
          }
        })
      }
    });
    return printarray;
  }

  private TriggerUnsavedChagesDetected(isDirty: boolean, isAlreadyTriggered: boolean) {
    this.tabopen.unsavedChangedDetected({ dirty: isDirty, Index: this.tabCounter });
    this.isUnsavedTriggered = isAlreadyTriggered;
  }

  //#endregion

  //#region Public Methods

  public ExpandAllNodes() {
    let expandedIds = [];
    this.trades.forEach(x => {
      if (x.Children.length > 0) {
        x.Children.forEach(y => {
          expandedIds.push(y.ID)
        })
        expandedIds.push(x.ID)
      }
    }
    )
    this.expandedKeys = expandedIds;
  }

  public HideDropDown(tabElement) {
    $(tabElement).find('.row-dropdown').css('display', 'none')
  }

  public OnNodeClick(node) {
    if (!this.treeViewList.isExpanded(node.item.dataItem, node.item.index)) {
      this.treeViewList.expandService.expand(node.item.index, node.item.dataItem)
    }
    else {
      this.treeViewList.expandService.collapse(node.item.index, node.item.dataItem)
    }
  }

  public CollapseAllNodes() {
    this.expandedKeys = []
  }

  public MoreOptionsClicked(event) {
    if (window.innerHeight < $(event.target).offset().top + 100) {
      if (!$(event.target).parents('.dropdown-toggle').find('.dropdown-menu').hasClass('drop-up'))
        $(event.target).parents('.dropdown-toggle').find('.dropdown-menu').addClass('drop-up')
    }
    else {
      if ($(event.target).parents('.dropdown-toggle').find('.dropdown-menu').hasClass('drop-up'))
        $(event.target).parents('.dropdown-toggle').find('.dropdown-menu').removeClass('drop-up')
    }
    $(event.target).parents('.dropdown-toggle').find('.dropdown-menu').removeClass('row-dropdown');
    $(this._elementRef.nativeElement).find('.row-dropdown').css('display', 'none')
    $(event.target).parents('.dropdown-toggle').find('.dropdown-menu').toggle();
    $(event.target).parents('.dropdown-toggle').find('.dropdown-menu').addClass('row-dropdown');
    event.stopPropagation();
  }

  public OpenNewTrade() {
    this.modalOptions.showTrade = true;
    this.IntializeTradeForm();
  }

  public ImageUploaded(selfRef, formType, DragAndDropImage, UploadImageBtn, ImagePreview, DeletePreview) {
    if (this.tradeForm != undefined) {
      this.tradeForm.markAsDirty();
    }
    if (this.categoryForm != undefined) {
      this.categoryForm.markAsDirty();
    }
    if (this.subCategoryForm != undefined) {
      this.subCategoryForm.markAsDirty();
    }
    this.ReadURL(selfRef.target, formType, DragAndDropImage, UploadImageBtn, ImagePreview, DeletePreview)
  }

  public SaveTrade() {
    if (this.tradeForm.valid) {
        let tradeName = this.tradeForm.controls["Name"].value;
        if (this.tradeForm.value.ID == "") { //save new trade
          this.tradeForm.value.ID = CommonMethods.GetID();
          this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
          this.dataService.addTrade(this.tradeForm.value).subscribe(response => {
          this.allTrades.push(response);
          this.SortList();
          this.QuickSearch();
          //this.setFilters({ advanceFilterActive: true, applyAdvanceFilter: true });
          this.modalOptions.showTrade = false;
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          this.toastr.success("Trade " + tradeName + " created", "Success!")
          this.TriggerUnsavedChagesDetected(false, false)
          if (this.destroyTab) {
            setTimeout(() => {
              this.tabopen.DestroyTab(this.tabCounter)
            }, 100)

          }
        }, error => {
          this.destroyTab = false;
          this.toastr.showMultiLineError(error.error.Message, "Error")
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          //this.spinnerProgress = false;
        })
      }
      else { // update/edit existing trade
        this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
        this.dataService.editTrade(this.tradeForm.value).subscribe(response => {
          let trade = this.allTrades.find(x => x.ID == response.ID);
          trade.Name = tradeName;
          trade.ImagePath = response.ImagePath;
          trade.ModifyDate = response.ModifyDate;
          // let allTradesNode = this.allTrades.find(x => x.ID == response.ID);
          // allTradesNode = trade;

          // trade.Children.forEach(CategoryChildren => {
          //   CategoryChildren.ModifyDate=trade.ModifyDate;
          //     CategoryChildren.Children.forEach(subCategoryChildren => {
          //       subCategoryChildren.ModifyDate=trade.ModifyDate;
          //     });
          // });
          trade.Children = response.Children;


          this.modalOptions.showTrade = false;
          this.modalOptions.isEdit = false;
          this.QuickSearch();
          //this.setFilters({ advanceFilterActive: true, applyAdvanceFilter: true });
          this.SortList();
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          this.toastr.success("Trade " + tradeName + " updated", "Success!")
          this.TriggerUnsavedChagesDetected(false, false)
          if (this.destroyTab) {
            setTimeout(() => {
              this.tabopen.DestroyTab(this.tabCounter)
            }, 100)
          }
        }, error => {
          this.destroyTab = false;
          this.toastr.showMultiLineError(error.error.Message, "Error")
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          //this.spinnerProgress = false;
        })
      }
    }
    else {
      this.destroyTab = false;
      this.commonMethods.markFormGroupTouched(this.tradeForm);
      $(this.viewChildTradeForm.nativeElement).find('.form-control.ng-invalid').first().focus();
    }
  }

  public SaveCategory() {
    if (this.categoryForm.valid) {
        let categoryName = this.categoryForm.controls["Name"].value;
        if (this.categoryForm.value.ID == "") { // new category
          this.categoryForm.value.ID = CommonMethods.GetID();
          this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
          this.dataService.addCategory(this.categoryForm.value.ParentId, this.categoryForm.value).subscribe(response => {
          let trade = this.allTrades.find(x => x.ID == this.categoryForm.value.ParentId)
          trade.Children.push(response);
          this.modalOptions.showCategory = false;
          this.SortList();
          this.QuickSearch([this.categoryForm.value.ParentId]);
          //this.setFilters({ advanceFilterActive: true, applyAdvanceFilter: true });
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          this.toastr.success("Category " + categoryName + " created", "Success!")
          this.TriggerUnsavedChagesDetected(false, false)
          if (this.destroyTab) {
            setTimeout(() => {
              this.tabopen.DestroyTab(this.tabCounter)
            }, 100)
          }
        }, error => {
          this.destroyTab = false;
          this.toastr.showMultiLineError(error.error.Message, "Error")
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          //this.spinnerProgress = false;
        })
      }
      else { // save edited category
        this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
        this.dataService.editCategory(this.categoryForm.value.ParentId, this.categoryForm.value).subscribe(response => {
          let trade = this.allTrades.find(x => x.ID == this.categoryForm.value.OldParentId);
          if (this.categoryForm.value.ParentId != this.categoryForm.value.OldParentId) {
            //new category created with different Id
            let categoryIndex = trade.Children.findIndex(x => x.ID == response.ID);
            response.Children = trade.Children[categoryIndex].Children;
            trade.Children.splice(categoryIndex, 1);
            let newtrade = this.allTrades.find(x => x.ID == this.categoryForm.value.ParentId);
            newtrade.Children.push(response);
            
            // let newAllTradesNode = this.allTrades.find(x => x.ID == this.categoryForm.value.ParentId);
            // newAllTradesNode = newtrade;
          } else {
            let category = trade.Children.find(x => x.ID == response.ID);
            category.Name = categoryName;
            category.ImagePath = response.ImagePath;
            category.ModifyDate = response.ModifyDate;
            // category.Children.forEach(subCategoryChildren => {
            //   subCategoryChildren.ModifyDate=category.ModifyDate;
            // });
            category.Children=response.Children;
          }
          // let allTradesNode = this.allTrades.find(x => x.ID == this.categoryForm.value.OldParentId);
          // allTradesNode = trade;

          this.modalOptions.showCategory = false;
          this.SortList();
          this.QuickSearch([this.categoryForm.value.ParentId]);
          //this.setFilters({ advanceFilterActive: true, applyAdvanceFilter: true });
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          this.toastr.success("Category " + categoryName + " updated", "Success!")
          this.TriggerUnsavedChagesDetected(false, false)
          if (this.destroyTab) {
            setTimeout(() => {
              this.tabopen.DestroyTab(this.tabCounter)
            }, 100)
          }
        }, error => {
          this.destroyTab = false;
          this.toastr.showMultiLineError(error.error.Message, "Error")
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          //this.spinnerProgress = false;
        })
      }
    }
    else {
      this.destroyTab = false;
      this.commonMethods.markFormGroupTouched(this.categoryForm);
      $(this.viewChildCategoryForm.nativeElement).find('.form-control.ng-invalid').first().focus();
    }
  }

  public OpenEdit(dataItem) {
    if (!this.permissionPipe.transform(ActionName.EditCategory)) {
      return
    }
    if (this.trades.findIndex(x => x.ID == dataItem.ID) > -1) {
      this.modalOptions.showTrade = true;
      this.IntializeTradeForm(dataItem);
    }
    else if (this.trades.findIndex(x => x.ID == dataItem.ParentID) > -1) {
      this.modalOptions.showCategory = true;
      this.IntializeCategoryForm(dataItem)
    }
    else {
      let TradeID = this.FindTradeID(dataItem.ParentID);
      this.categoryList = this.trades.find(x => x.ID == TradeID).Children;
      this.modalOptions.showSubCategory = true;
      this.IntializeSubCategoryForm(TradeID, dataItem);
    }
    this.modalOptions.isEdit = true;
  }

  public ConfirmDelete(ref) {
    this.showDeleteConfirmation = false;
    if (ref) {
      let dataItem = this.deleteDataItem;
      if (this.trades.findIndex(x => x.ID == dataItem.ID) > -1) {
        this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
        this.dataService.deleteTrade(dataItem).subscribe(
          response => {
            //this.trades.splice(this.trades.findIndex(x => x.ID == dataItem.ID), 1);
            this.allTrades.splice(this.allTrades.findIndex(x => x.ID == dataItem.ID), 1);
            this.QuickSearch();
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.success("Trade " + dataItem.Name + " deleted", "Success!")
          }, error => {
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.showMultiLineError(error.error.Message, "Error")
            //this.spinnerProgress = false;
          });
      }
      else if (this.trades.findIndex(x => x.ID == dataItem.ParentID) > -1) {
        this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
        this.dataService.deleteCategory(dataItem).subscribe(
          response => {
            let trade = this.trades.find(x => x.ID == dataItem.ParentID);
            trade.Children.splice(trade.Children.findIndex(x => x.ID == dataItem.ID), 1)
            // let allTradesNode = this.allTrades.find(x => x.ID == dataItem.ParentID);
            // allTradesNode = trade;
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.success("Category " + dataItem.Name + " deleted", "Success!")
          }, error => {
            this.toastr.showMultiLineError(error.error.Message, "Error")
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            //this.spinnerProgress = false;
          });
      }
      else {
        let TradeID = this.FindTradeID(dataItem.ParentID);
        this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
        this.dataService.deleteSubCategory(TradeID, dataItem).subscribe(
          response => {
            let trade = this.trades.find(x => x.ID == TradeID);
            let category = trade.Children.find(x => x.ID == dataItem.ParentID)
            category.Children.splice(category.Children.findIndex(x => x.ID == dataItem.ID), 1)
            // let allTradesNode = this.allTrades.find(x => x.ID == TradeID);
            // allTradesNode = trade;
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.success("Sub-Category " + dataItem.Name + " deleted", "Success!")
          }, error => {
            this.toastr.showMultiLineError(error.error.Message, "Error")
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            //this.spinnerProgress = false;
          });
      }
    }
    else {
      this.deleteDataItem = null;
    }
  }

  public Delete(dataItem) {
    if (!this.permissionPipe.transform(ActionName.EditCategory))
      return;
    this.deleteDataItem = dataItem;
    this.showDeleteConfirmation = true;
    if (this.trades.findIndex(x => x.ID == dataItem.ID) > -1) {
      this.deleteMessage = "Deleting this Trade will permanently delete all underlying categories and move all items to Trade: None";
    }
    else if (this.trades.findIndex(x => x.ID == dataItem.ParentID) > -1) {
      this.deleteMessage = "Deleting this Category will permanently delete all underlying sub-categories and move all items to Trade: None, Category: None.";

    }
    else {
      this.deleteMessage = "Deleting this Sub-Category will move this item to Trade: None, Category: None.";
    }
  }

  public SaveSubCategory() {
    if (this.subCategoryForm.valid) {
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      let subCategoryName = this.subCategoryForm.controls["Name"].value;
        if (this.subCategoryForm.value.OldParentId == "") {
            if (this.subCategoryForm.value.ID == "")
                this.subCategoryForm.value.ID = CommonMethods.GetID();
        this.dataService.addSubCategory(this.subCategoryForm.value.TradeId, this.subCategoryForm.value.ParentId, this.subCategoryForm.value).subscribe(response => {
          let trade = this.allTrades.find(x => x.ID == this.subCategoryForm.value.TradeId)
          let category = trade.Children.find(x => x.ID == this.subCategoryForm.value.ParentId);
          category.Children.push(response);
          this.modalOptions.showSubCategory = false;
          this.SortList();
          this.QuickSearch([this.subCategoryForm.value.TradeId, this.subCategoryForm.value.ParentId]);
          //this.setFilters({ advanceFilterActive: true, applyAdvanceFilter: true });
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          this.toastr.success("Sub-Category " + subCategoryName + " created", "Success!")
          this.TriggerUnsavedChagesDetected(false, false)
          if (this.destroyTab) {
            setTimeout(() => {
              this.tabopen.DestroyTab(this.tabCounter)
            }, 100)
          }
        }, error => {
          this.destroyTab = false;
          this.toastr.showMultiLineError(error.error.Message, "Error")
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          //this.spinnerProgress = false;
        })
      }
      else {
        this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
        this.dataService.editSubCategory(this.subCategoryForm.value.TradeId, this.subCategoryForm.value.ParentId, this.subCategoryForm.value).subscribe(response => {
          if (this.subCategoryForm.value.TradeId != this.subCategoryForm.value.OldTradeId) {
            let trade = this.allTrades.find(x => x.ID == this.subCategoryForm.value.OldTradeId)
            if (this.subCategoryForm.value.ParentId != this.subCategoryForm.value.OldParentId) {
              let category = trade.Children.find(x => x.ID == this.subCategoryForm.value.OldParentId);
              let subCategoryIndex = category.Children.findIndex(x => x.ID == response.ID)
              category.Children.splice(subCategoryIndex, 1);
              let newTrade = this.allTrades.find(x => x.ID == this.subCategoryForm.value.TradeId);
              let newCategory = newTrade.Children.find(x => x.ID == response.ParentID);
              newCategory.Children.push(response);
            }
            // let allTradesNode = this.allTrades.find(x => x.ID == this.subCategoryForm.value.OldTradeId)
            // allTradesNode = trade;
          } else {
            let trade = this.allTrades.find(x => x.ID == this.subCategoryForm.value.OldTradeId)
            let category = trade.Children.find(x => x.ID == this.subCategoryForm.value.OldParentId);
            if (this.subCategoryForm.value.ParentId != this.subCategoryForm.value.OldParentId) {
              let subCategoryIndex = category.Children.findIndex(x => x.ID == this.subCategoryForm.value.ID)
              category.Children.splice(subCategoryIndex, 1);
              let newCategory = trade.Children.find(x => x.ID == this.subCategoryForm.value.ParentId);
              newCategory.Children.push(response);
            } else {
              let subCategory = category.Children.find(x => x.ID == response.ID);
              subCategory.Name = subCategoryName;
              subCategory.ImagePath = response.ImagePath;
              subCategory.ModifyDate = response.ModifyDate;
            }
            // let allTradesNode = this.allTrades.find(x => x.ID == this.subCategoryForm.value.OldTradeId)
            // allTradesNode = trade;
          }
          this.modalOptions.showSubCategory = false;
          this.SortList();
          this.QuickSearch([this.subCategoryForm.value.TradeId, this.subCategoryForm.value.ParentId]);
          //this.setFilters({ advanceFilterActive: true, applyAdvanceFilter: true });
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          this.toastr.success("Sub-Category " + subCategoryName + " updated", "Success!")
          this.TriggerUnsavedChagesDetected(false, false)
          if (this.destroyTab) {
            setTimeout(() => {
              this.tabopen.DestroyTab(this.tabCounter)
            }, 100)
          }
        }, error => {
          this.destroyTab = false;
          this.toastr.showMultiLineError(error.error.Message, "Error")
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          //this.spinnerProgress = false;
        })
      }
    }
    else {
      this.destroyTab = false;
      this.commonMethods.markFormGroupTouched(this.subCategoryForm);
      $(this.viewChildSubCategoryForm.nativeElement).find('.form-control.ng-invalid').first().focus();
    }
  }

  public RemovePreview(type, ImageFileControl1, ImageFileControl2, DragAndDropImage, UploadImageBtn, ImagePreview, DeletePreview) {
    if (this.tradeForm != undefined) {
      this.tradeForm.markAsDirty();
    }
    if (this.categoryForm != undefined) {
      this.categoryForm.markAsDirty();
    }
    if (this.subCategoryForm != undefined) {
      this.subCategoryForm.markAsDirty();
    }
    $(ImageFileControl1).val("");
    $(ImageFileControl2).val("");
    if (type == "trade") {
      this.tradeForm.controls['ImagePath'].patchValue("")
    }
    else if (type == "category") {
      this.categoryForm.controls['ImagePath'].patchValue("")
    }
    else {
      this.subCategoryForm.controls['ImagePath'].patchValue("")
    }
    //$(ImagePreview).attr('src', '');
    $(DeletePreview).hide();
    $(ImagePreview).hide();
    $(DragAndDropImage).show();
    $(UploadImageBtn).hide();
  }

  public ReadURL(input, formType, DragAndDropImage, UploadImageBtn, ImagePreview, DeletePreview) {
    let exts = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
    if (input.files && input.files[0]) {
      if (!this.commonMethods.ValidExtension(input.value, exts)) {
        this.toastr.error("Sorry, uploaded file is invalid, allowed extensions are: " + exts.join(", "), "Error");
        $(input).val("");
        return;
      }
      if(input.files[0].size > 4194304) // 4 m.b.
      {
        this.toastr.error("Sorry, File size is too large. Maximum file size permitted is 4 MB", "Error");
        $(input).val("");
        return;
      }
      let postData = new FormData();
      postData.append('files', input.files[0])
      this.imageUploading = true;
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      this.dataService.UploadImage(postData).subscribe(response => {
        if (formType == 'trade') {
          this.tradeForm.controls['ImagePath'].patchValue(response[0].StorageLocation)
        }
        else if (formType == 'category') {
          this.categoryForm.controls['ImagePath'].patchValue(response[0].StorageLocation)
        }
        else {
          this.subCategoryForm.controls['ImagePath'].patchValue(response[0].StorageLocation)
        }
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        $(ImagePreview).show();
        $(DragAndDropImage).hide();
        $(UploadImageBtn).show();
        $(DeletePreview).show()
        this.imageUploading = false;
      }, error => {
        this.imageUploading = false;
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        this.toastr.showMultiLineError(error.error.Message, "Error")
      })
    }
  }

  public OpenNewCategory() {
    this.modalOptions.showCategory = true;
    this.IntializeCategoryForm();

  }

  public OpenNewSubCategory() {
    this.modalOptions.showSubCategory = true;
    this.IntializeSubCategoryForm();
    this.categoryList = [];

  }

  public PopulateCatDropdown() {
    if (this.subCategoryForm.controls['TradeId'].value != "") {
      let trade = this.allTrades.find(x => x.ID == this.subCategoryForm.controls['TradeId'].value);
      this.categoryList = trade.Children;
    } else {
      this.subCategoryForm.controls['ParentId'].patchValue("");
      this.subCategoryForm.controls['ParentId'].markAsUntouched();
      this.categoryList = [];
    }
  }
  
  public CloseModal(type) {
    if (type == 'Trade') {
      if (this.tradeForm.dirty) {
        this.tabopen.DestroyTab(this.tabCounter, "modal")
      }
      else {
        this.modalOptions.isEdit = false;
        this.modalOptions.showTrade = false;
      }
    }
    else if (type == 'Category') {
      if (this.categoryForm.dirty) {
        this.tabopen.DestroyTab(this.tabCounter, "modal")
      }
      else {
        this.modalOptions.isEdit = false;
        this.modalOptions.showCategory = false;
      }
    }
    else if (type == 'SubCategory') {
      if (this.subCategoryForm.dirty) {
        this.tabopen.DestroyTab(this.tabCounter, "modal")
      }
      else {
        this.modalOptions.isEdit = false;
        this.modalOptions.showSubCategory = false
      }
    }

  }

  public QuickSearch(expandedElements = []) {
    let searchString = this.customFilterForm.controls['searchString'].value;
    this.expandedKeys = expandedElements;
    if (searchString.trim() == "") {
      this.trades = this.allTrades;
      this.SetFilters({ applyAdvanceFilter: false, advanceFilterActive: true })
      return;
    }
    else {
      searchString = searchString.toUpperCase();
    }
    let trades = [];
    this.allTrades.forEach(x => {
      if (x.Name.toUpperCase().indexOf(searchString) > -1) {
        trades.push(x);
        x.Children.forEach(y => {
          if (y.Name.toUpperCase().indexOf(searchString) > -1) {
            this.expandedKeys.indexOf(x.ID) > -1 ? "" : this.expandedKeys.push(x.ID);
            y.Children.forEach(z => {
              if (z.Name.toUpperCase().indexOf(searchString) > -1) {
                if (this.expandedKeys.indexOf(y.ID) == -1) { this.expandedKeys.push(y.ID) }
                if (this.expandedKeys.indexOf(x.ID) == -1) {
                  this.expandedKeys.push(x.ID)
                }
              }
            })
          }
          else {
            y.Children.forEach(z => {
              if (z.Name.toUpperCase().indexOf(searchString) > -1) {
                if (this.expandedKeys.indexOf(y.ID) == -1) { this.expandedKeys.push(y.ID) }
                if (this.expandedKeys.indexOf(x.ID) == -1) {
                  this.expandedKeys.push(x.ID)
                }
              }
            })
          }
        })
      }
      else {
        x.Children.forEach(y => {
          if (y.Name.toUpperCase().indexOf(searchString) > -1) {
            if (trades.indexOf(x) == -1) {
              trades.push(x)
              this.expandedKeys.push(x.ID)
            }
            y.Children.forEach(z => {
              if (z.Name.toUpperCase().indexOf(searchString) > -1) {
                if (this.expandedKeys.indexOf(y.ID) == -1) {
                  this.expandedKeys.push(y.ID)
                }
              }
            })
          }
          else {
            y.Children.forEach(z => {
              if (z.Name.toUpperCase().indexOf(searchString) > -1) {
                if (trades.indexOf(x) == -1) {
                  trades.push(x)
                  this.expandedKeys.push(x.ID)
                  this.expandedKeys.push(y.ID)
                }
              }
            })
          }
        })
      }
    })
    this.trades = trades;
    this.SetFilters({ applyAdvanceFilter: false, advanceFilterActive: true })
    this.NoRecordFound(this.trades);
    this.SortList();
  }
  
  public ClearQuickSearch() {
    this.trades = this.allTrades;
    this.customFilterForm.controls['searchString'].patchValue("");
    this.QuickSearch();
    this.NoRecordFound(this.trades);
  }

  public SetFilters(setFilterBtn: { applyAdvanceFilter: boolean, advanceFilterActive: any } 
    = { advanceFilterActive: true, applyAdvanceFilter: null }) {
    let filterArray = <FormArray>this.customFilterForm.controls['searchFilters'];
    if (setFilterBtn.applyAdvanceFilter) {
      if (filterArray.value.length == 1 && filterArray.value[0].value == "") {
        this.advanceFiltersValues = null;
        this.QuickSearch();
      }
      else {
        this.advanceFiltersValues = filterArray.value;
        this.QuickSearch();
      }

      if (setFilterBtn.advanceFilterActive && this.advanceFiltersValues != null) {
        $(this.elAdvancedSearch.nativeElement).addClass("active")
      }
      else {
        $(this.elAdvancedSearch.nativeElement).removeClass("active")
      }
    }
    this.AdvanceSearch(this.advanceFiltersValues);
    this.NoRecordFound(this.trades);
    //this.getTrades();
  }

  public ToggleAdvanceSearch() {
    this.elAdvancedSearchOption.DisplayToggle();
    $(this.elAdvancedSearch.nativeElement).toggleClass("search__hidden");
  }

  public ExportToExcel() {
    this.exportService.ExportToExcel(this.InitiateExportData());
  }

  public ExportToPDF() {
    this.exportService.ExportToPDF(this.InitiateExportData());
  }

  public ExportToCSV() {
    this.exportService.ExportToCSV(this.InitiateExportData());
  }

  //#endregion
}
